var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43763 11.0255C7.16358 10.715 7.1932 10.241 7.50379 9.96695L11.5038 6.43757C11.7873 6.18741 12.2127 6.18741 12.4962 6.43757L16.4962 9.96695C16.8068 10.241 16.8364 10.715 16.5624 11.0255C16.2883 11.3361 15.8144 11.3658 15.5038 11.0917L12.75 8.66192V16.9999C12.75 17.4141 12.4142 17.7499 12 17.7499C11.5858 17.7499 11.25 17.4141 11.25 16.9999V8.66192L8.49622 11.0917C8.18563 11.3658 7.71168 11.3361 7.43763 11.0255Z",
    fill: "#B6B8D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUparrow);
export default __webpack_public_path__ + "static/media/icn-uparrow.e5584000963930020add9c1c79eb44c6.svg";
export { ForwardRef as ReactComponent };